import $ from 'jquery'
import {Module} from '../plugins/_application'
/*
 -------------------------------
 Class
 -------------------------------
 */

export default class Faq extends Module {
  ready () {
    if($('.mtt-faq').length){

    	$(document).on('click', '.faq-title', function(){

    		var parent = $(this).parent('.faq-item');

    		if(parent.hasClass('active')){
    			parent.removeClass('active');
    		}else {
    			parent.addClass('active');
    		}

    	});

    }
  }
}
